import DtoReferencialInt from './DtoReferencialInt'

export default class DtoReferencial extends DtoReferencialInt {
    constructor(obj = {}) {
        super(obj)
        this.code = (this.code - 1).toString()
    }
}
